import React from 'react';

const BlogCard = (props) => {
    const { img, name, link, date } = props.blog;
    return (
        <div className="card mr-4 mt-4 col-md-3" style={{ borderRadius: "6px", border: "none" }}>
            <div className="d-flex justify-content-center mt-4" style={{ height: "200px" }}>
                <img className="card-img-top img-fluid" src={img} alt="" />
            </div>

            <div className="card-body text-left">
                <h6 className="card-title font-weight-bolder name" style={{ color: "#0b9e43" }}>{name}</h6>
                <p style={{ fontSize: "10px", color: "gray" }}>Published on <span style={{ fontSize: "13px" }}>{date}</span></p>
                <a href={link} style={{ color: '#06c' }} target="blank"> Read More{'>>'} </a>
            </div>
        </div>
    );
};

export default BlogCard;